export enum ErrorScreenType {
  PermissionDenied = 'Permission Denied',
  SaveBankAccount = 'Save Bank Account',
  SaveAccountDetails = 'Save Account Details',
  EnvSetup = 'Env Setup',
}
